import request from '@/utils/request'
// import addReceipt from '@/views/receipts/addReceipt.vue'
/**
 *
 * 收据管理
 *
 **/
// 获取年份列表
export const getYears = () =>
  request({
    'url': `/consultant/Receipts/getAllYears`,
    'method': 'GET',
  })


// 获取全部交易信息（table）
export const getAllTransctionsInfo = (params: any) =>
  request({
    'url': `/consultant/Receipts/getAllTransactionInfo`,
    'method': 'GET',
    params
  })

// 获取交易概览信息（header-span）
export const getInstitutions = () =>
  request({
    'url': `/consultant/Receipts/getInstitutions`,
    'method': 'GET',
  })

// 获取交易概览信息（header-span）
export const getTransactionInfoByInstitution = (params: any) =>
  request({
    'url': `/consultant/Receipts/getInstitutionTransactionInfo`,
    'method': 'GET',
    params
  })



export const getReceipts = (params: any) =>
  request({
    'url': `/consultant/Receipts/pageQuery`,
    'method': 'GET',
    params
  })


// 导出收据pdf
export function exportReceipt(receiptId: number, params: any) {
  return request({
    url: `/consultant/Receipts/${receiptId}/export`,
    method: 'get',
    responseType: "blob",
    params
  })
}

// 获取客单学生姓名列表
export const getClienteleStuNames = () =>
  request({
    'url': `/consultant/Receipts/getStuNames`,
    'method': 'GET'
  })

export const addReceipt = (data: any) =>
  request({
    'url': `/consultant/Receipts`,
    'method': 'POST',
    data
  })





// ----------------------------------------------------------------------------
